import React from "react";

export function DateField({ id, label, value, onChange }) {
  return (
    <div className="relative">
      <input
        id={id}
        type="date"
        required
        value={value}
        onChange={onChange}
        className="block w-full rounded border border-gray-300 bg-white py-3 px-3 text-base focus:outline-none focus:border-blue-500"
      />
      <label
        htmlFor={id}
        className="absolute left-3 bg-white px-1 transition-all top-0 -translate-y-1/2 text-xs text-gray-700"
      >
        {label}
      </label>
    </div>
  );
}
